import { render, staticRenderFns } from "./cfsDataStatistics.vue?vue&type=template&id=6fa44b16&scoped=true"
import script from "./cfsDataStatistics.vue?vue&type=script&lang=js"
export * from "./cfsDataStatistics.vue?vue&type=script&lang=js"
import style0 from "./cfsDataStatistics.vue?vue&type=style&index=0&id=6fa44b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa44b16",
  null
  
)

export default component.exports